import "./_fleche.scss";

import cx from "classnames";
import {ReactElement} from "react";

export function Fleche({
  classname,
  variant = "orange",
}: {
  classname?: string;
  variant: "orange" | "blanc";
}): ReactElement {
  const variantFleche = (variant: string): Record<string, boolean> => {
    return {
      "fleche-blanc": variant.includes("blanc"),
      "fleche-orange": variant.includes("orange"),
    };
  };
  return (
    <div className={cx("fleche", classname, variantFleche(variant))}>
      <div className="fleche-rectangle"></div>
      <div className="fleche-rectangle"></div>
    </div>
  );
}
